import React from 'react'
import PropTypes from 'prop-types'
import {
  MONTH_NAMES_SHORT,
  MONTH_CHART_KEY,
  feedCodeToTitle,
} from '../../constants'
import CFXProReactTable from '../cfxProReactTable'
import {reactTableColumn} from '../../helpers/reactTable'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {connect} from 'react-redux'
import {updateFeedData, updateIsFetchingFeedData} from '../../actions'
import api from '../../api'
import {CFXProFormatNumber} from '../../helpers/formatting'

@connect((state) => {
  const {
    data: {dtn},
    app: {isFetchingFeedData},
  } = state

  return {
    isFetchingFeedData,
    data: dtn,
  }
})
@api
class FuturesFeed extends React.Component {
  buildTableData(data) {
    if (data == null) {
      return []
    }
    const {
      match: {
        params: {feed},
      },
    } = this.props

    return data[feed].feed.map((element) => {
      let monthName = MONTH_NAMES_SHORT[element.month - 1]
      let monthChartValue = MONTH_CHART_KEY[monthName]
      let actualSymbol = element.symbol
      if (element.symbol === 'C') actualSymbol = 'ZC'
      if (element.symbol === 'CD') actualSymbol = '6C'

      return {
        month: element.month,
        year: element.year,
        title: monthName + ' ' + element.year,
        feed: feed,
        roundTo: feed === 'cdn' ? 4 : 2,
        last: Number(element.lastValue),
        change: Number(element.changeValue),
        chartSymbol: actualSymbol + monthChartValue + element.year,
      }
    })
  }

  render() {
    const {
      data,
      isFetchingFeedData,
      match: {
        params: {feed},
      },
      apiInstance,
      dispatch,
    } = this.props
    let tableData = this.buildTableData(data)
    let footerDate = data == null ? null : data.lastUpdated

    return (
      <div>
        <CFXProReactTable
          fixedHeaders={true}
          footerText={buildLastUpdateFooter(
            'Courtesy of DTN\nPrice as of (date) at (time)',
            footerDate,
          )}
          titleText={feedCodeToTitle(feed)}
          highlightColumns={['MONTH']}
          rightButtonIconName={
            isFetchingFeedData ? 'fa-sync-alt fa-spin' : 'fa-sync-alt'
          }
          rightButtonCallback={() => {
            dispatch(updateIsFetchingFeedData(true))
            apiInstance.get('getdata').then((data) => {
              dispatch(updateFeedData(data))
              dispatch(updateIsFetchingFeedData(false))
            })
          }}
          data={tableData}
          loading={isFetchingFeedData}
          className="-striped -highlight"
          showPagination={false}
          defaultPageSize={-1}
          columns={[
            reactTableColumn('MONTH', 'title', '', (cell) => {
              return (
                <div className="cell-value">
                  {
                    <div>
                      <i className="fa fa-chart-line" />{' '}
                      {CFXProFormatNumber(
                        cell.value,
                        cell.original.roundTo != null
                          ? cell.original.roundTo
                          : 2,
                      )}
                    </div>
                  }
                </div>
              )
            }),
            reactTableColumn('LAST', 'last'),
            reactTableColumn('CHANGE', 'change'),
          ]}
          getTrProps={(state, rowInfo, column, instance) => {
            return {
              className: 'cfx-selectable',
              onClick: (e, handleOriginal) => {
                this.props.history.push(
                  `/futures/pricingchart/${rowInfo.original.chartSymbol}`,
                )
              },
            }
          }}
        />
        <div className="cfx-cme-logo" />
      </div>
    )
  }
}

const propTypeFuturesFeedItem = PropTypes.shape({
  changeValue: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  lastValue: PropTypes.string.isRequired,
  month: PropTypes.number.isRequired,
  symbol: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
})

const propTypeFuturesFeed = PropTypes.shape({
  latest: propTypeFuturesFeedItem.isRequired,
  all: PropTypes.arrayOf(propTypeFuturesFeedItem).isRequired,
})

FuturesFeed.propTypes = {
  data: PropTypes.shape({
    lastUpdate: PropTypes.instanceOf(Date),
    livecattle: propTypeFuturesFeed,
    feeder: propTypeFuturesFeed,
    cdn: propTypeFuturesFeed,
    corn: propTypeFuturesFeed,
  }),
}

export default FuturesFeed



// WEBPACK FOOTER //
// ./src/components/futures/feed.js